import { Input, Radio } from 'components/Form'
import { getMessage } from 'lib/translator'
import React from 'react'

const SPLASH_STATUS_OPTIONS = [
  {
    value: true,
    text: getMessage(`apphome.enabled`),
  },
  {
    value: false,
    text: getMessage(`apphome.disabled`),
  },
]

const FilterSplashscreen = ({ generateStateMappers }) => {
  return (
    <>
      <Input
        id="name"
        name="name"
        type="text"
        label={getMessage('apphome.filter.searchByName')}
        placeholder={getMessage('app.campaign.name.placeholder')}
        {...generateStateMappers({
          stateKeys: ['name'],
          loseEmphasisOnFill: true,
        })}
      />
      <Radio
        label={getMessage('appbanner.status')}
        options={SPLASH_STATUS_OPTIONS}
        {...generateStateMappers({
          stateKeys: ['status'],
          loseEmphasisOnFill: true,
          defaultValue: 1,
        })}
      />
    </>
  )
}

export default FilterSplashscreen
